module.exports = __webpack_public_path__ + "img/yidao3instruction.21f37dee.png";